import { render, staticRenderFns } from "./ParticipantDifferingPolicyholder.vue?vue&type=template&id=2e675b2a"
import script from "./ParticipantDifferingPolicyholder.vue?vue&type=script&lang=js"
export * from "./ParticipantDifferingPolicyholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports